<template>
  <CustomDeleteDialog
    dialogTitle="حذف پکیج سوال مسابقه"
    dialogId="delete-question-package-confirmation-dialog"
    okTitle="حذف"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendDeleteMatchQuestionRequest"
  >
    <BCol cols="12" v-if="selectedPackage">
      <p>
        آیا از حذف پکیج
        <span style="font-weight: bold">
          {{ selectedPackage.name }}
        </span>
        اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    selectedPackage: {
      type: Object,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendDeleteMatchQuestionRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let deleteAMatchQuestionPackage = new DeleteAMatchQuestionPackage(
          _this
        );
        deleteAMatchQuestionPackage.setRequestParam({
          id: _this.selectedPackage.id,
        });
        await deleteAMatchQuestionPackage.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "پکیج با موفقیت حذف شد.",
              },
            });
            this.$bvModal.hide("delete-question-package-confirmation-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    BCol,
    CustomDeleteDialog,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { DeleteAMatchQuestionPackage } from "@/libs/Api/Matches";
</script>
